import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, unref as _unref, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-78305f86"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "auction" }
const _hoisted_2 = { class: "auction-content" }
const _hoisted_3 = { class: "auction-content-left" }
const _hoisted_4 = { class: "auction-content-left--top" }
const _hoisted_5 = { class: "price" }
const _hoisted_6 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "price-unit" }, "¥", -1))
const _hoisted_7 = { class: "price-value" }
const _hoisted_8 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", { class: "buyout-txt" }, "一口价购买该作品", -1))
const _hoisted_9 = {
  key: 0,
  class: "auction-content-left--bottom"
}
const _hoisted_10 = { class: "auction-content-right" }
const _hoisted_11 = /*#__PURE__*/_createTextVNode("去购买")

import { ref, inject } from "vue";
import { storeToRefs } from "pinia";
import {
  Popup as VanPopup,
  showFailToast,
  showLoadingToast,
  showConfirmDialog,
  closeToast,
} from "vant";
import MainButton from "@/components/MainButton";
import { DuButton } from "@frontend/dumpling";
import { useRouter } from "vue-router";
import { useUsersStore } from "@/store/user";
import { getQuery } from "@/utils/url";

export default /*#__PURE__*/_defineComponent({
  __name: 'ActionProduct',
  props: {
  contractPerformingConfig: {
    type: Object,
    required: true,
  },
},
  emits: [
  "onRefreshTokenDetail",
  "onConfirmChooseCount",
  "onInvokeApp",
],
  setup(__props, { emit }) {

const props = __props

const userStore = useUsersStore();

const router = useRouter();
const { userInfo, getIsLogin } = storeToRefs(userStore);




const buyoutDetailData: any = inject("buyoutDetailData");
const isOwner = inject("isOwner");

const onInvokeApp = () => {
  emit("onInvokeApp");
};

const handleBuy = () => {
  const { tokenId } = getQuery();
  const tradeId = buyoutDetailData.value?.product?.id;
  router.push(
    `/product-detail?tokenId=${tokenId}&tradeId=${tradeId}&tradeType=buyout`
  );
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("span", _hoisted_5, [
              _hoisted_6,
              _createElementVNode("span", _hoisted_7, _toDisplayString(_unref(buyoutDetailData).product?.price), 1)
            ]),
            _hoisted_8
          ]),
          (_unref(buyoutDetailData).product?.isFutureSelling)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(buyoutDetailData).product?.startTimeString), 1))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_unref(DuButton), {
            type: "recommend",
            size: "small",
            onClick: handleBuy
          }, {
            default: _withCtx(() => [
              _hoisted_11
            ]),
            _: 1
          })
        ])
      ]),
      (_unref(isOwner))
        ? (_openBlock(), _createBlock(_unref(MainButton), {
            key: 0,
            inactivated: "",
            full: "",
            extClass: "hugewidth2",
            text: "请去App操作",
            onOnInvokeApp: onInvokeApp
          }))
        : _createCommentVNode("", true)
    ])
  ]))
}
}

})